const LOADING_ID = 'loading-animator';

export class LoadingAnimator {
    private loader: JQuery<HTMLElement>;
    private loading: boolean;

    public constructor(container: JQuery<HTMLElement> = $('body')) {
        this.loading = false;

        let loader = container.find(`#${LOADING_ID}`);

        console.debug('loader', loader);
        if (loader.length === 0) {
            loader = this.getLoader();
            loader.hide();
            console.debug('loader', loader);
            container.append(loader);
        }

        this.loader = loader;
    }

    public isLoading(): boolean {
        return this.loading;
    }

    public startLoading(): boolean {
        console.debug('startLoading', this.loader);
        if (this.isLoading()) {
            return false;
        }
        this.loader.show();
        this.loading = true;
        return true;
    }

    public stopLoading() {
        this.loader.hide();
        this.loading = false;
    }

    private getLoader(): JQuery<HTMLElement> {
        const _template = `<div>
            <div class="loading_animator" id="${LOADING_ID}"><div class="loader-large"></div></div>
        </div>`;
        const template = $.parseHTML(_template);
        return $(template).find(`#${LOADING_ID}`);
    }
}
